import React from 'react';

import { MessageThreadHeader } from '../message-thread-header';

import { EmployeeMessages } from './employee-messages';

type InputProps = {
  orgId: number;
  employee: Employee;
  handleEmployeeClick: (
    employeeId: number,
    newSelectedTab: string,
  ) => (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onClose: () => void;
};

export const EmployeeThread = (props: InputProps) => {
  const { orgId, employee, handleEmployeeClick, onClose } = props;

  const recipientName = `${employee.Contact.Person.firstName}
              ${employee.nickname ? ` (${employee.nickname})` : ''}${' '}
              ${employee.Contact.Person.lastName}`;

  return (
    <>
      <MessageThreadHeader
        sublabel={employee.jobTitle || undefined}
        recipientName={recipientName}
        onClose={onClose}
        handleRecipientNameClick={handleEmployeeClick(employee.employeeId, 'DETAILS')}
        HeaderAction={{
          name: 'View Profile',
          handler: handleEmployeeClick(employee.employeeId, 'DETAILS'),
        }}
      />
      <div className="u-overflowY-auto u-border-top u-height-100 u-position-relative u-padding-2x">
        <div className="u-maxWidth-800px u-margin-0Auto">
          <EmployeeMessages orgId={orgId} employee={employee} onClose={onClose} />
        </div>
      </div>
    </>
  );
};
